import { useTranslation } from 'react-i18next';
import { Button, Card, Logo } from '@/components/ui';
import type { MaintenanceSection } from '../types/maintenance.types';
import { MaintenanceIcon, MaintenancePeriod } from './MaintenancePeriod';

interface MaintenanceScreenProps {
  section: MaintenanceSection;
  onRetry: () => void;
  retrying: boolean;
}

/**
 * Full-viewport block shown while the WHOLE app is in maintenance
 * (section `all`). Replaces the router entirely — login included.
 */
export function MaintenanceScreen({ section, onRetry, retrying }: MaintenanceScreenProps) {
  const { t } = useTranslation();

  return (
    <div className="grid min-h-dvh place-items-center bg-canvas px-4 py-10">
      <Card className="w-full max-w-lg p-8 text-center sm:p-10">
        <Logo width={160} className="mx-auto" />
        <div className="mx-auto mt-8 flex h-16 w-16 items-center justify-center rounded-full bg-warning-light text-[#9a6700]">
          <MaintenanceIcon className="h-8 w-8" />
        </div>
        <h1 className="mt-5 text-2xl font-bold text-ink">{t('maintenance.title')}</h1>
        <p className="mt-3 whitespace-pre-line text-ink-soft">{section.message ?? t('maintenance.default_message')}</p>
        <MaintenancePeriod section={section} className="mt-4 text-sm text-ink-mute" />
        <Button variant="outline" className="mt-8" onClick={onRetry} loading={retrying}>
          {t('maintenance.retry')}
        </Button>
      </Card>
    </div>
  );
}
